export const mobileMenu = () => {
  $('.menu-toggle').click(function (e) {
    e.stopPropagation();
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-is-active');
  });

  $('.site-navigation .menu-item-has-children > a').click(function () {
    $(this).toggleClass('.is-active');
    return false;
  });

  //default body padding for a mobile header
  function bodyPadding() {
    $('.single-nominees .site-content').css(
      'padding-top',
      $('.site-header')[0].offsetHeight
    );
  }

  if ($('body.single-nominees').length) {
    $(window).on('resize', bodyPadding);
    bodyPadding();
  }
};
